// CreateTeam.js
import React, { useEffect, useState } from "react";
import { FiUsers, FiSave } from "react-icons/fi";
import axios from "axios";
import { apiURL } from "../config/config";
import Swal from "sweetalert2";
import BackButton from "../components/BackButton"; // ✅ ปุ่มย้อนกลับ

const CreateTeam = () => {
  const [teamName, setTeamName] = useState("");
  const [group, setGroup] = useState("");
  const [newGroup, setNewGroup] = useState("");
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  // โหลด group จาก API
  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const res = await axios.get(`${apiURL}teams`);
        const uniqueGroups = [
          ...new Set(res.data.map((team) => team.group).filter(Boolean)),
        ];
        setGroups(uniqueGroups);

        localStorage.setItem("teams", JSON.stringify(res.data));
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "ไม่สามารถโหลดรายชื่อทีมได้",
          confirmButtonColor: "#ef4444",
          background: "#1f2937",
          color: "#fff",
        });
      }
    };
    fetchTeams();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selectedGroup = group === "__new" ? newGroup.trim() : group;

    if (!teamName || !selectedGroup) {
      Swal.fire({
        icon: "warning",
        title: "กรุณากรอกข้อมูลให้ครบ",
        confirmButtonColor: "#f59e0b",
        background: "#1f2937",
        color: "#fff",
      });
      return;
    }

    setLoading(true);

    try {
      const payload = { name: teamName, group: selectedGroup };
      const res = await axios.post(`${apiURL}teams`, payload);

      // ✅ แสดง SweetAlert สำเร็จ
      await Swal.fire({
        icon: "success",
        title: "สร้างทีมสำเร็จแล้ว ✅",
        showConfirmButton: false,
        timer: 1500,
        background: "#1f2937",
        color: "#fff",
      });

      const existingTeams = JSON.parse(localStorage.getItem("teams")) || [];
      const updatedTeams = [...existingTeams, res.data];
      localStorage.setItem("teams", JSON.stringify(updatedTeams));

      // เคลียร์ฟอร์ม
      setTeamName("");
      setGroup("");
      setNewGroup("");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "สร้างทีมไม่สำเร็จ ❌",
        text: "กรุณาลองอีกครั้งภายหลัง",
        confirmButtonColor: "#ef4444",
        background: "#1f2937",
        color: "#fff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 px-4 md:px-6 py-6 transition-colors duration-300">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 shadow-md rounded-xl border border-gray-200 dark:border-gray-700 p-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
          <div className="flex items-center gap-3 mb-3 sm:mb-0">
            <FiUsers className="text-indigo-500 text-2xl" />
            <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
              Create Team / Team Group
            </h1>
          </div>
          <BackButton label="ย้อนกลับ" />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Team Group */}
          <div>
            <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
              Team Group (หมวดทีม) <span className="text-red-500">*</span>
            </label>
            <select
              value={group}
              onChange={(e) => setGroup(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-indigo-400 focus:outline-none"
            >
              <option value="">-- เลือก Team Group --</option>
              {groups.map((g, i) => (
                <option key={i} value={g}>
                  {g}
                </option>
              ))}
              <option value="__new">+ เพิ่ม Team Group ใหม่</option>
            </select>

            {group === "__new" && (
              <input
                type="text"
                value={newGroup}
                onChange={(e) => setNewGroup(e.target.value)}
                placeholder="ใส่ชื่อ Team Group ใหม่"
                className="mt-2 w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-indigo-400 focus:outline-none"
              />
            )}
          </div>

          {/* Team Name */}
          <div>
            <label className="block text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
              Team Name (ชื่อทีมจริง) <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-indigo-400 focus:outline-none"
              placeholder="เช่น AE1, Media2"
              required
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center gap-2 bg-indigo-500 hover:bg-indigo-600 text-white px-5 py-2 rounded-lg font-medium transition-all disabled:opacity-50"
            >
              <FiSave className="text-lg" />
              {loading ? "กำลังบันทึก..." : "Save Team"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTeam;
